import React from 'react';

interface BlackCheckMarkIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
  fill?: string;
}

const BlackCheckMarkIcon: React.FC<BlackCheckMarkIconProps> = ({
  width = 18,
  height = 16,
  className,
  fill = 'rgb(34, 34, 34)'
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M 16.1483 5.46078 L 7.14828 14.4608 C 7.09604 14.5131 7.034 14.5546 6.96572 14.5829 C 6.89743 14.6112 6.82423 14.6258 6.75031 14.6258 C 6.67639 14.6258 6.6032 14.6112 6.53491 14.5829 C 6.46662 14.5546 6.40459 14.5131 6.35234 14.4608 L 2.41484 10.5233 C 2.3093 10.4177 2.25 10.2746 2.25 10.1253 C 2.25 9.97605 2.3093 9.83289 2.41484 9.72734 C 2.52039 9.6218 2.66355 9.5625 2.81281 9.5625 C 2.96208 9.5625 3.10523 9.6218 3.21078 9.72734 L 6.75031 13.2676 L 15.3523 4.66484 C 15.4579 4.5593 15.601 4.5 15.7503 4.5 C 15.8996 4.5 16.0427 4.5593 16.1483 4.66484 C 16.2538 4.77039 16.3131 4.91355 16.3131 5.06281 C 16.3131 5.21208 16.2538 5.35523 16.1483 5.46078 Z"
        fill={fill}
      />
    </svg>
  );
};

export default BlackCheckMarkIcon;
